import { gql } from "@apollo/client";

export const GET_FRECUENCIA_DISTRIBUIDOR_BY_ID = gql`
query FrecuenciaDistribuidorById($IdFrecuenciaDistribuidor: Int!){
    frecuenciaDistribuidorById(idFrecuenciaDistribuidor: $IdFrecuenciaDistribuidor) {    
        frecuenciaDistribuidor {
            idFrecuenciaDistribuidor,
            idProveedorDistribuidor,
            kilometroDestino,
            costoEntregaInmediata,
            idDeposito,
            activo,
            idFrecuenciaModoDespacho,
            idProveedorDistribuidorNavigation {
              idProveedorDistribuidor,
              razonSocial,
              codigoSAP
            },
            frecuenciaDistribuidorCP{
              idFrecuenciaDistribuidorCP,
              idFrecuenciaDistribuidor,
              idCodigoPostal,
              idCodigoPostalNavigation {
                idCodigoPostal,
                cP,
                idTipoZona,
                idProvincia,
                localidad,
                idProvinciaNavigation {
                  idProvincia,
                  descripcion
                }
              }
            }
        },
        frecuenciaDistribuidorDetalle {
              idFrecuenciaDistribuidorDetalle,
              idFrecuenciaDistribuidor,
              horaSalida,
              demoraHoraDestino,
              metodoCobroBulto,
              metodoCobroKilo,
              metodoCobroKm,
              horaSalidaString,
              frecuenciaDistribuidorDetalleDia {
                idFrecuenciaDistribuidorDetalleDia,
                idFrecuenciaDistribuidorDetalle,
                numeroDia
              }
        }
    }
  }
`;